import React from 'react';
import CommentItem from './CommentItem';
import styles from './CommentsList.module.css';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Spinner from './UI/Spinner';

const CommentsList = () => {

  const params = useParams();
  const allComments = useSelector(state => state.comment.comments);
  const notificationStatus = useSelector(state => state.notification.status);
  const selectedComment = allComments.filter(comment => comment.quoteId === params.quoteId) || [];
/*   let commentsOfQuote = [];

  const selectedComment = allComments.find(comment => comment.id === params.quoteId) || [];
  for (const property in selectedComment) {
    if(typeof selectedComment[property] === 'object') {
      commentsOfQuote.push(selectedComment[property])
    }
  } */

  let content = selectedComment.map((comment, index) => <CommentItem key={`comment-${index}`} id={`comment-${index}`} commentText={comment.commentData.text} />)

  if(selectedComment.length === 0) {
    content = <p>No comments. Be the first one to comment!</p>
  }

  if(notificationStatus === 'loading') {
    content = <Spinner />
  }

  return (
    <div className={styles['comments-list']}>
        {content}
    </div>
  )
}

export default CommentsList